import { SVGProps } from "react";

export function IdSuccess(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={97}
      height={97}
      viewBox="0 0 97 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.2} cx={48.4993} cy={48.5} r={39.2727} fill="#DEDFE0" />
      <mask
        id="mask0_14274_38980"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={5}
        width={65}
        height={84}
      >
        <path
          d="M28.8636 52.8636C28.8636 50.4536 30.8173 48.5 33.2273 48.5H61.0455C62.8529 48.5 64.3182 47.0347 64.3182 45.2273V9.22726C64.3182 7.41978 62.8529 5.95453 61.0454 5.95453H3.77272C1.96525 5.95453 0.5 7.41978 0.5 9.22726L0.5 85.5909C0.5 87.3984 1.96525 88.8636 3.77273 88.8636H25.5909C27.3984 88.8636 28.8636 87.3984 28.8636 85.5909V52.8636Z"
          fill="#008669"
        />
      </mask>
      <g mask="url(#mask0_14274_38980)">
        <rect
          x={11.4062}
          y={17.9546}
          width={43.6364}
          height={61.0909}
          rx={2.18182}
          fill="#D5E8EA"
        />
        <path
          d="M32.8673 36.3059C24.0221 36.3059 16.8594 43.4846 16.8594 52.3299C16.8594 61.1751 24.0221 68.3538 32.8673 68.3538C41.7286 68.3538 48.9073 61.1751 48.9073 52.3299C48.9073 43.4846 41.7286 36.3059 32.8673 36.3059ZM43.9719 45.9203H39.2448C38.7321 43.9173 37.995 41.9944 37.0335 40.2158C39.9819 41.2253 42.4336 43.2763 43.9719 45.9203ZM32.8833 39.5748C34.2133 41.4977 35.2549 43.6289 35.9439 45.9203H29.8228C30.5118 43.6289 31.5533 41.4977 32.8833 39.5748ZM20.4808 55.5347C20.2244 54.5091 20.0642 53.4355 20.0642 52.3299C20.0642 51.2242 20.2244 50.1506 20.4808 49.1251H25.8969C25.7687 50.1827 25.6726 51.2402 25.6726 52.3299C25.6726 53.4195 25.7687 54.4771 25.8969 55.5347H20.4808ZM21.7948 58.7395H26.5218C27.0346 60.7424 27.7717 62.6653 28.7331 64.444C25.7847 63.4345 23.3331 61.3994 21.7948 58.7395ZM26.5218 45.9203H21.7948C23.3331 43.2603 25.7847 41.2253 28.7331 40.2158C27.7717 41.9944 27.0346 43.9173 26.5218 45.9203ZM32.8833 65.0849C31.5533 63.1621 30.5118 61.0309 29.8228 58.7395H35.9439C35.2549 61.0309 34.2133 63.1621 32.8833 65.0849ZM36.6329 55.5347H29.1337C28.9895 54.4771 28.8773 53.4195 28.8773 52.3299C28.8773 51.2402 28.9895 50.1666 29.1337 49.1251H36.6329C36.7772 50.1666 36.8893 51.2402 36.8893 52.3299C36.8893 53.4195 36.7772 54.4771 36.6329 55.5347ZM37.0335 64.444C37.995 62.6653 38.7321 60.7424 39.2448 58.7395H43.9719C42.4336 61.3834 39.9819 63.4345 37.0335 64.444ZM39.8698 55.5347C39.998 54.4771 40.0941 53.4195 40.0941 52.3299C40.0941 51.2402 39.998 50.1827 39.8698 49.1251H45.2859C45.5423 50.1506 45.7025 51.2242 45.7025 52.3299C45.7025 53.4355 45.5423 54.5091 45.2859 55.5347H39.8698Z"
          fill="#AACFD3"
        />
        <rect
          opacity={0.9}
          x={19.043}
          y={24.5}
          width={28.3636}
          height={6.54545}
          rx={1.09091}
          fill="white"
        />
      </g>
      <rect
        x={31.043}
        y={50.6818}
        width={58.9091}
        height={37.0909}
        rx={2.18182}
        fill="#33777E"
      />
      <rect
        opacity={0.9}
        x={37.5898}
        y={77.9545}
        width={45.8182}
        height={3.27273}
        rx={1.63636}
        fill="white"
      />
      <rect
        opacity={0.6}
        x={55.043}
        y={70.3181}
        width={28.3636}
        height={3.27273}
        rx={1.63636}
        fill="white"
      />
      <rect
        opacity={0.6}
        x={55.043}
        y={63.7727}
        width={28.3636}
        height={3.27273}
        rx={1.63636}
        fill="white"
      />
      <rect
        opacity={0.6}
        x={55.043}
        y={57.2272}
        width={28.3636}
        height={3.27273}
        rx={1.63636}
        fill="white"
      />
      <rect
        opacity={0.9}
        x={37.5898}
        y={57.2272}
        width={13.0909}
        height={16.3636}
        rx={2.18182}
        fill="white"
      />
      <mask
        id="mask1_14274_38980"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={64}
        y={12}
        width={23}
        height={23}
      >
        <rect
          x={64.8633}
          y={12.5}
          width={21.8182}
          height={21.8182}
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask1_14274_38980)">
        <circle cx={75.7586} cy={23.4208} r={7.4539} fill="white" />
        <path
          d="M74.3388 24.9814L72.4986 23.118C72.2998 22.9316 72.0551 22.8384 71.7646 22.8384C71.474 22.8384 71.2218 22.9355 71.0078 23.1296C70.8059 23.3392 70.705 23.5916 70.705 23.8866C70.705 24.1817 70.8137 24.4146 71.0311 24.5854L73.5934 27.171C73.784 27.3884 74.0296 27.4971 74.3303 27.4971C74.631 27.4971 74.89 27.3884 75.1074 27.171L80.3951 21.8834C80.6125 21.6846 80.7212 21.4438 80.7212 21.1611C80.7212 20.8783 80.6137 20.6221 80.3988 20.3926C80.1839 20.2063 79.9268 20.117 79.6275 20.1247C79.3283 20.1325 79.0794 20.2296 78.881 20.4159L74.3388 24.9814ZM75.7629 33.2273C74.4153 33.2273 73.1411 32.9742 71.9403 32.4678C70.7395 31.9616 69.6946 31.2639 68.8055 30.3749C67.9165 29.4859 67.2189 28.442 66.7126 27.2433C66.2063 26.0447 65.9531 24.7716 65.9531 23.424C65.9531 22.0724 66.2067 20.7984 66.7139 19.6018C67.2212 18.4053 67.9201 17.361 68.8107 16.469C69.7014 15.577 70.7446 14.8743 71.9403 14.361C73.136 13.8476 74.4074 13.5909 75.7545 13.5909C77.1072 13.5909 78.383 13.8469 79.582 14.3588C80.781 14.8706 81.8257 15.5714 82.7164 16.4612C83.607 17.3509 84.3085 18.3948 84.8209 19.593C85.3333 20.7911 85.5895 22.0677 85.5895 23.4227C85.5895 24.7767 85.3328 26.0501 84.8195 27.2429C84.3061 28.4357 83.6034 29.4776 82.7114 30.3688C81.8194 31.2601 80.7762 31.9593 79.5818 32.4665C78.3874 32.9737 77.1144 33.2273 75.7629 33.2273Z"
          fill="#1F9E80"
        />
      </g>
    </svg>
  );
}
